// import { StrictMode } from "react";
import React from "react";
import ReactDOM from "react-dom";
// import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// const root = createRoot(document.getElementById("root"));
// root.render(
//   <StrictMode>
//     <App />
//   </StrictMode>
// );

ReactDOM.render(<App />, document.getElementById("root"));
